import store from '../../store'
import moment from 'moment'
import { merge } from 'lodash'
import MembresiaPlan from '../Membresias/MembresiaPlan.js'
import PGSHelper from '../../helpers/PGSHelper.js';
import Currencies from '../Currencies.js';

export default class Membresia {
    static typeSearch      = "local" //online || local
    Activo                 = true;
    Id                     = null;
    Plan                   = "";
    Clientes               = {};
    Titular                = ""
    FechaCreacion          = "";

    constructor(data = null) {
        this.Activo        = (data?.Activo)?data.Activo:true;
        this.Id            = (data?.Id)?data.Id:null;
        this.Periodo       = (data?.Periodo)?data.Periodo:'';
        this.Plan          = (data?.Plan)?data.Plan:'';
        this.Clientes      = (data?.Clientes)?data.Clientes:{};
        this.Deuda         = (data?.Deuda)?data.Deuda: {C:0,M:Currencies.getCurrencyDefault()};
        this.Titular       = (data?.Titular)?data.Titular:{};
        this.Upat          = (data?.Upat)?data.Upat:null;
        this.Dlat          = (data?.Dlat)?data.Dlat:null;
        this.ExtraParams   = (data?.ExtraParams)?data.ExtraParams:{};
        this.DiaCargo      = (data?.DiaCargo)?data.DiaCargo:1;
        this.DiasProrroga  = (data?.DiasProrroga)?data.DiasProrroga:0
        this.FechaCreacion = (data?.FechaCreacion)?data.FechaCreacion:0;
        this.Code          = (data?.Code)?data.Code:{Pre:"",Pos:""};
        this.PlanE         = (data?.PlanE)?data.PlanE:{CA: {C:0,M:Currencies.getCurrencyDefault()},CPA:{C:0,M:Currencies.getCurrencyDefault()},TIA:0,};
        this.Contadores    = (data?.Contadores)?data.Contadores:{}; //objeto con indices numericos
    }

    static getPropertyModel(){
        let model = new Membresia();
        return model;
    }

    static getById(id){
    /* if(this.typeSearch == "online"){
            let data = await store.getters.getFirebaseApp.firestore.collection("MBS_Membresias").doc(id).get();
            if(!data.exists){
                return false;
            }else{
                let doc = {Id:data.ref.id,...data.data()};
                return new Membresia(doc);
            }
        }else*/ if(this.typeSearch == "local"){
            let pgsHelper  = new PGSHelper();
            let datos = pgsHelper.getById(store.getters["dataLists/getMbsMembresias"],'id',id);
            if(datos){datos.Id = id;}else{return false}
            return new Membresia(datos);
        }
    }

    static getMembresiasList(){
    /* if(this.typeSearch == "online"){
            let data = await store.getters.getFirebaseApp.firestore.collection("MBS_Membresias")
            .where("Tenant", "==",store.getters.getFirebaseApp.tenant).get();
            if(data.empty){
                return [];
            }else{
                let doc = data.docs.map(doc=>{return {Id:doc.ref.id,...doc.data()}});
                let membresias = [];
                doc.forEach((documento)=>{
                    membresias.push(new Membresia(documento));
                })
                return membresias;
            }
        }else if(this.typeSearch == "local"){*/
            let membresia = [];
            let localData = store.getters["dataLists/getMbsMembresias"];
            localData.forEach((element)=>{
                if(!element.Dlat){
                  membresia.push(new Membresia({ Id: element.id, ...element }));
                } 
            })
            return membresia;
        /*}*/
    }

    async getPlan(){
        return await MembresiaPlan.getById(this.Plan);
    }

    async getClientes(){
        return this.Clientes;
    }

    async getContadoresByClientIndex(index){
        return this.Contadores[index];
    }

    getClientesAsArray(){
        return Object.keys(this.Clientes);
    }

}